import { useEffect, useRef, useState } from "react";

function useCountUp(target, duration = 2200, trigger = false) {
    const [count, setCount] = useState(0);
    const rafRef = useRef(null);

    useEffect(() => {
        if (!trigger) return;

        const end = Number(target);
        if (isNaN(end) || end <= 0) {
            setCount(end || 0);
            return;
        }

        let startTime = null;

        const step = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);
            // ease-out cubic
            const eased = 1 - Math.pow(1 - progress, 2);
            setCount(Math.floor(eased * end));

            if (progress < 1) {
                rafRef.current = requestAnimationFrame(step);
            } else {
                setCount(end);
            }
        };

        rafRef.current = requestAnimationFrame(step);

        return () => {
            if (rafRef.current) cancelAnimationFrame(rafRef.current);
        };
    }, [target, trigger, duration]);

    return count;
}

export default useCountUp;
